import { types } from "../types/types";

const initialState = {
  ruleFlows: [],
  ruleFlowsModule: []
};

export const ruleFlowReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RULEFLOW_START_LOADING:
      return {
        ...state,
        ruleFlows: action.payload,
      };

       case types.RULEFLOW_BY_MODULE_START_LOADING:
      return {
        ...state,
        ruleFlowsModule: action.payload,
      };

    default:
      return state;
  }
};
